import React from "react";

const EmailShare = () => (
  <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 0V18H26.1V0H0ZM4.32909 2H21.7709L13.05 7.78125L4.32909 2ZM2.00769 2.875L12.4853 9.84375L13.05 10.1875L13.6147 9.84375L24.0923 2.875V16H2.00769V2.875Z" fill="#0098F0"/>
</svg>
);

export default EmailShare;
